import OptionValue from '../../../Communication/OptionValue';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import ExportQueueService from '../../../Services/ExportQueueService';
import AdHocExportItem from './AdHocExportItem';

export default class AdHocExportWindowDescription {
  static titleForCreate = 'AdHoc Export';
  static titleForEdit = 'AdHoc Export';
  static finishButtonLabel = 'Start Adhoc Export';
  static itemType = AdHocExportItem;
  static serviceFunction = (edited) => ExportQueueService.StartAdHocExport(edited);
  static waitForServiceFunction = () => false;
  static messageOnSuccess =
    'The payment exports queues will be created in the background, you will receive a notification.';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'Offices',
          label: 'Offices',
          className: 'col',
          type: InputTypesEnum.MultiChoice,
          selectvalues: AdHocExportWindowDescription.getOwnOfficeOptions,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        { fieldName: 'Notes', label: 'Notes', className: 'col-12', type: InputTypesEnum.Notes },
      ],
    },
  ];

  static getOwnOfficeOptions(item) {
    let options = [];
    item.AllOffice.forEach((o) => options.push(new OptionValue(o.name, o.officeId)));
    return options;
  }
}
